import React from "react";
import "./style.css";

const Vote = ({ isDone }) => (
  <div className="vote">
    <svg
      className="vote__svg"
      viewBox="0 0 659 389"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#DEDED4"
          fillRule="nonzero"
          d="M656.6 389H567v-97.512l89.6-17.388z"
        />
        <path
          d="M657.5 274v115"
          stroke="#3C3C3B"
          strokeWidth="3"
          strokeLinecap="square"
        />
        <path
          stroke="#3C3C3B"
          strokeWidth="3"
          fill="#FFF"
          fillRule="nonzero"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M656.6 272.1h-570l-84.2 115h570z"
        />
        <g
          fillRule="nonzero"
          stroke="#3C3C3B"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="3"
        >
          <path fill="#3D3D3B" d="M457.3 340.8H163.6L181 316h293.6z" />

          <g className="vote__action" transform={isDone ? `translate(0, 140)` : `translate(0, 0)`}>
            <path
              fill="#FFF"
              d="M235.3 340.6L206.6 197l145.8-34.7 38.7 177.3z"
            />
            <path fill="#FFF" d="M234.4 325.3L206.6 197l138.3-21L383 340.8z" />
            <path fill="#FFF" d="M231.3 340.8l-29-129L344.9 176 383 340.8z" />
            <path
              d="M217.777 194.68l8.126-1.899 19.763-4.7c-8.326-5.298-18.359-19.196-18.86-20.496-.903-2.5 4.915-16.798 4.915-16.798 3.913-2.5 14.347 1 14.347 1 1.705.4 3.01 1.2 4.414 2.1 5.919 3.8 21.77 17.497 24.278 55.192 0 0 .301 19.397 11.738 12.398 5.116-3.1 6.42-8.099 6.42-13.298 2.91 3.8 6.12 3.7 10.334.8 4.113-2.9 5.417-7.899 5.417-7.899.402-4 .602-7.899.602-11.698 13.343 6.499 11.939-13.398 11.939-13.398-.1-2.5-.201-5-.402-7.4 10.534 2.4 9.13-16.297 9.13-16.297-1.405-27.896-20.366-48.293-20.366-48.293-13.242-11.699-48.556-35.695-48.757-36.095L254.896 59 194 97.895l6.22 9.998s9.13 11.898.903 33.895c-3.11 8.3-8.628 28.096-3.712 37.195 1.806 3.7 12.24 11.399 20.366 15.698z"
              fill="#FFF"
            />
            <path fill="#F66" d="M100 2l88.435 99L261 54.205 218.18 2z" />
            <path
              d="M293 208s-2.415-23.4-11.168-43.1C272.98 145.2 260 138 260 138M309 190s-6.14-27.33-14.757-42.502C285.626 132.426 278 127 278 127M320 168s-6.4-34.3-24-50"
              fill="#FFF"
            />
          </g>
        </g>
      </g>
      <path
        d="M100 380h370"
        fill="red"
        strokeWidth="72"
        strokeLinecap="square"
      />

      <rect fill="white" x="100" y="344" width="370" height="42" />
      <path
        d="M0 387.5h570"
        stroke="#3D3D3B"
        strokeWidth="3"
        strokeLinecap="square"
      />
      <path
        d="M163 342.5h293"
        stroke="#3D3D3B"
        strokeWidth="3"
        strokeLinecap="square"
      />
    </svg>
  </div>
);

export default Vote;



// WEBPACK FOOTER //
// ./src/scenes/Intro/components/Vote/index.js